module.exports = __webpack_public_path__ + "analysis.1AyWkOsX.svg";